<template>
    <div v-if="!reload" id="course-creator-page" class="course-creator-page-custom-class">
        <div v-if="loader" id="loader"></div>
        <div class="w-layout-grid content-3-col-grid course-nav-container">
            <div class="side-content">
                <div class="fixed-parent">
                    <div class="fixed pr-2">
                        <template v-if="showSection">
                            <div
                                class="sticky-col-content course-nav-container"
                                style="overflow:hidden; top:0;"
                            >
                                <div class="section-title-wrap">
                                    <h2 class="section-title">
                                        {{ trans("course.add_course_content") }}
                                    </h2>
                                </div>
                                <draggable
                                    :clone="cloneSection"
                                    :group="{
                                        name: 'people',
                                        pull: 'clone',
                                        put: false
                                    }"
                                    :list="contentBlocks"
                                    :sort="false"
                                    class="w-layout-grid content-tiles-grid course-builder-grid-custom"
                                    tag="div"
                                >
                                    <div
                                        v-for="(element, idx) in contentBlocks"
                                        :key="'block' + idx"
                                        class="content-tile w-inline-block"
                                    >
                                        <div class="icon">
                                            <img
                                                :src="'/images/' + element.image"
                                                alt=""
                                                class="mb-0 inactive-icon"
                                                loading="lazy"
                                                style="opacity: 1;"
                                            />
                                            <img
                                                :src="'/images/' + element.image_hover"
                                                alt=""
                                                class="mb-0 active-icon"
                                                loading="lazy"
                                                style="opacity: 0;"
                                            />
                                        </div>
                                        <div>
                                            {{ trans("course.creator.sections." + element.name) }}
                                        </div>
                                    </div>
                                </draggable>
                            </div>
                        </template>
                        <hr v-if="showSection"/>
                        <div v-if="showSection" class="mt-3">
                            <div class="section-title-wrap">
                                <h2 class="section-title">
                                    {{ form.courseName }}
                                </h2>
                            </div>
                            <div class="section-map">
                                <div
                                    v-for="element in map"
                                    :key="'mapsection' + element.id"
                                    class="map-first"
                                >
                                    <div
                                        class="map-wrapp"
                                        @click="expandMap($event, element);openMap(element)"
                                    >
                                        <a :id="'creator-map-' + element.type + '-' + element.id"
                                            :class="'map-' + element.type"
                                            :href="'#element-' + element.type + '-' + element.id"
                                            class="creator-map"
                                            @click="openMap(element)"
                                        >
                                            {{ element.name ? element.name : trans("messages.course_creator_default_level_1_title") }}
                                        </a>
                                        <i  v-if="element.type==1 && element.children.length"
                                            :class="'map-icon-' + element.id"
                                            class="fas fa-angle-down"
                                        ></i>
                                    </div>
                                    <div :class="'children-' + element.id"
                                        class="children-map">
                                        <a v-for="(child, idx) in element.children"
                                            :id="'creator-map-' + child.type + '-' + child.id"
                                            :key="'mapchild' + element.id + child.id + idx"
                                            :class="'map-' + child.type"
                                            :href="'#element-' + child.type + '-' + child.id"
                                            class="child-map creator-map"
                                            @click="openMap(child)">
                                            {{ child.name ? child.name : trans('course.untitled.' + (isNaN(child.type) ? child.type : 'chapter')) }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="course-creator-component" class="middle-content middle-content-initial-state">
                <h2 v-if="!form.id">
                    {{ trans("messages.course_creator_page_title") }}
                </h2>
                <form class="corse-creator-form">
                    <template v-if="!form.id">
                        <div class="row">
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="courseTitle">{{
                                            trans("messages.course_creator_title")
                                        }}</label>
                                    <input
                                        id="courseTitle"
                                        v-model="form.courseName"
                                        maxlength="255"
                                        :placeholder="
                                            trans(
                                                'messages.course_creator_title'
                                            )
                                        "
                                        class="form-control"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="category">{{
                                            trans(
                                                "messages.course_creator_category"
                                            )
                                        }}</label>
                                    <select
                                        id="category"
                                        v-model="form.category"
                                        class="form-control"
                                    >
                                        <option value="0">{{
                                                trans(
                                                    "messages.course_creator_category_default"
                                                )
                                            }}
                                        </option>
                                        <option
                                            v-for="(category, id) in categories"
                                            :value="category.id"
                                        >{{ category.name }}
                                        </option
                                        >
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="courseDescription">{{
                                    trans(
                                        "messages.course_creator_category_description"
                                    )
                                }}</label>
                            <textarea
                                id="courseDescription"
                                v-model="form.courseDescription"
                                :maxlength="
                                    courseDescriptionType == 'characters'
                                        ? courseDescriptionLenght
                                        : ''
                                "
                                class="form-control"
                                row="3"
                            ></textarea>
                        </div>
                        <div class="d-flex justify-content-end">
                            <button type="button" class="btn btn-primary mt-2 ml-auto" @click.prevent="saveOnNext">Next</button>
                        </div>
                    </template>
                    <template v-else>
                        <div class="course-top">
                            <div class="course-name-block">
                                <h2 class="section-title mb-0">
                                    {{ form.courseName }}
                                </h2>
                            </div>
                            <div class="parent-wrap _2">
                                <div
                                    v-if="form.published"
                                    class="exposed-action published"
                                    data-placement="bottom"
                                    data-toggle="tooltip"
                                    title="Show/Hide Course"
                                    @click="
                                        form.published = 0;
                                        courseChange();
                                    "
                                >
                                    <img
                                        :src="'/images/eye-grey.png'"
                                        alt=""
                                        class="status-icon"
                                        loading="lazy"
                                    />
                                </div>
                                <div
                                    v-else
                                    class="exposed-action unpublished"
                                    data-placement="bottom"
                                    data-toggle="tooltip"
                                    title="Show/Hide Course"
                                    @click="
                                        form.published = 1;
                                        courseChange();
                                    "
                                >
                                    <img
                                        :src="'/images/hidden-red.png'"
                                        alt=""
                                        class="status-icon"
                                        loading="lazy"
                                    />
                                </div>
                            </div>
                            <div
                                class="exposed-action analog-clock-container pointer"
                            >
                                <world-clock
                                    :icon-mode="true"
                                    @click="showWorldClocks = true"
                                ></world-clock>
                            </div>
                            <div class="parent-wrap">
                                <a
                                    class="exposed-action preview hover-image course-icon-wrap"
                                    target="_blank"
                                >
                                    <img
                                        :src="'/images/marlms-desktop.png'"
                                        alt=""
                                        class="inactive-icon status-icon"
                                        loading="lazy"
                                        style="opacity: 1;"
                                    />
                                    <img
                                        :src="
                                            '/images/marlms-desktop-orange.png'
                                        "
                                        alt=""
                                        class="active-icon status-icon"
                                        loading="lazy"
                                        style="opacity: 0;"
                                    />
                                </a>
                            </div>
                            <div class="top-actions">
                                <div
                                    class="w-dropdown"
                                    data-delay="0"
                                    data-hover="1"
                                    style=""
                                >
                                    <div class="course-icon-wrap hover-image">
                                        <img
                                            :src="
                                                '/images/marlms-more-grey.png'
                                            "
                                            alt=""
                                            class="inactive-icon"
                                            loading="lazy"
                                            style="opacity: 1;"
                                        />
                                        <img
                                            :src="
                                                '/images/marlms-more-orange.png'
                                            "
                                            alt=""
                                            class="active-icon"
                                            loading="lazy"
                                            style="opacity: 0;"
                                        />
                                    </div>

                                    <nav
                                        id="w-dropdown-list-3"
                                        aria-labelledby="w-dropdown-toggle-3"
                                        class="dropdown-list w-dropdown-list"
                                    >
                                        <a
                                            class="action-link w-inline-block pointer"
                                            tabindex="0"
                                            @click="
                                                (showCoauthors = true),
                                                    (showInformations = false)
                                            "
                                        >
                                            <div class="dropdown-icon-wrap mr">
                                                <img
                                                    :src="
                                                        '/images/co-authors-grey.png'
                                                    "
                                                    alt=""
                                                    class="inactive-icon"
                                                    loading="lazy"
                                                    style="opacity: 1;"
                                                />
                                                <img
                                                    :src="
                                                        '/images/co-authors-orange.png'
                                                    "
                                                    alt=""
                                                    class="active-icon"
                                                    loading="lazy"
                                                    style="opacity: 0;"
                                                />
                                            </div>
                                            <div>
                                                {{
                                                    trans(
                                                        "course.add_course_view_coauthors"
                                                    )
                                                }}
                                            </div>
                                        </a>
                                        <a
                                            class="action-link w-inline-block pointer"
                                            tabindex="0"
                                            @click="
                                                (showInformations = true),
                                                    (showCoauthors = false)
                                            "
                                        >
                                            <div class="dropdown-icon-wrap mr">
                                                <img
                                                    :src="
                                                        '/images/marlms-edit-grey.png'
                                                    "
                                                    alt=""
                                                    class="inactive-icon"
                                                    loading="lazy"
                                                    style="opacity: 1;"
                                                /><img
                                                :src="
                                                        '/images/marlms-edit-orange.png'
                                                    "
                                                alt=""
                                                class="active-icon"
                                                loading="lazy"
                                                style="opacity: 0;"
                                            />
                                            </div>
                                            <div>
                                                {{
                                                    trans(
                                                        "course.add_course_edit_information"
                                                    )
                                                }}
                                            </div>
                                        </a>
                                        <export-button-menu
                                            v-if="canExport"
                                            :elementId="course.id"
                                            :exportTypes="courseExportTypes"
                                            elementType="course"
                                        />
                                        <a
                                            class="action-link w-inline-block"
                                            href="/course-creator"
                                            tabindex="0"
                                        >
                                            <div class="dropdown-icon-wrap mr">
                                                <img
                                                    :src="
                                                        '/images/marLMS-new-grey.png'
                                                    "
                                                    alt=""
                                                    class="inactive-icon"
                                                    loading="lazy"
                                                    style="opacity: 1;"
                                                />
                                                <img
                                                    :src="
                                                        '/images/marLMS-new-orange.png'
                                                    "
                                                    alt=""
                                                    class="active-icon"
                                                    loading="lazy"
                                                    style="opacity: 0;"
                                                />
                                            </div>
                                            <div>
                                                {{
                                                    trans(
                                                        "course.add_course_new_course"
                                                    )
                                                }}
                                            </div>
                                        </a>
                                        <a
                                            :data-confirm-message="
                                                trans(
                                                    'messages.course_delete_dialog_details'
                                                )
                                            "
                                            :data-confirm-title="
                                                trans(
                                                    'messages.course_delete_dialog_confirm'
                                                )
                                            "
                                            class="action-link delete w-inline-block"
                                            tabindex="0"
                                            @click="deleteCourse($event)"
                                        >
                                            <div class="dropdown-icon-wrap mr">
                                                <img
                                                    :src="
                                                        '/images/delete-red.png'
                                                    "
                                                    alt=""
                                                    class="inactive-icon"
                                                    loading="lazy"
                                                />
                                            </div>
                                            <div>
                                                {{
                                                    trans(
                                                        "course.add_course_delete_course"
                                                    )
                                                }}
                                            </div>
                                        </a>
                                    </nav>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="showInformations"
                            class="description-block border-bottom pb-3 mb-3"
                        >
                            <div class="form-group">
                                <label for="courseTitle">{{
                                        trans("course.add_course_course_title")
                                    }}</label>
                                <input
                                    id="courseTitle"
                                    v-model="form.courseName"
                                    :placeholder="
                                        trans('messages.course_creator_title')
                                    "
                                    class="form-control"
                                    type="text"
                                    @change="courseChange()"
                                    @keydown.enter.prevent="courseChange()"
                                />
                                <!--                                <i class="far fa-edit edit-title-i"></i>-->
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <div
                                        class="form-group"
                                        style="height: 100%"
                                    >
                                        <label for="courseDescription">{{
                                                trans(
                                                    "messages.course_creator_category_description"
                                                )
                                            }}</label>
                                        <textarea
                                            id="courseDescription"
                                            v-model="form.courseDescription"
                                            :maxlength="
                                                courseDescriptionType ==
                                                'characters'
                                                    ? courseDescriptionLenght
                                                    : ''
                                            "
                                            class="form-control"
                                            row="3"
                                            style="min-height: 135px; height: 80%"
                                            @change="courseChange"
                                            v-on:keyup="limitDescription"
                                        ></textarea>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="category"
                                        >{{
                                                trans(
                                                    "messages.course_creator_category"
                                                )
                                            }}
                                        </label>
                                        <a href="#" @click.stop.prevent="showAddCategoryModal = true">
                                            <i
                                                class="fas fa-plus ml-2 pointer"
                                                data-placement="top"
                                                data-toggle="tooltip"
                                                :title="trans('course.category.edit.add_category')"
                                            ></i>
                                        </a>
                                        <select
                                            id="category"
                                            v-model="courseCategory"
                                            class="form-control"
                                            @change="courseChange"
                                        >
                                            <option value="0">{{
                                                    trans(
                                                        "messages.course_creator_category_default"
                                                    )
                                                }}
                                            </option>
                                            <option
                                                v-for="(category,
                                                id) in categories"
                                                :value="category.id"
                                            >{{ category.name }}
                                            </option
                                            >
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label for="chooseFile">{{
                                                trans(
                                                    "course.add_course_course_cover"
                                                )
                                            }}</label>
                                        <div v-if="showImage">
                                            <i
                                                :data-confirm-message="
                                                    trans(
                                                        'messages.remove_course_image_confirm_dialog_message'
                                                    )
                                                "
                                                :data-confirm-title="
                                                    trans(
                                                        'messages.remove_course_image_confirm_dialog_title'
                                                    )
                                                "
                                                class="fas fa-trash ml-2 pointer"
                                                data-placement="top"
                                                data-toggle="tooltip"
                                                style="float: right"
                                                title="Remove image"
                                                @click="removeImage($event)"
                                            ></i>
                                            <img
                                                :src="course.image"
                                                alt="Card image cap"
                                                class="image-preview mb-3"
                                                style="display: block"
                                            />
                                        </div>
                                        <input
                                            id="chooseFile"
                                            accept="image/*"
                                            class="form-control image-input-form-control image-preview-input"
                                            name="image"
                                            type="file"
                                            @change="uploadImage($event)"
                                        />
                                        Max: 2MB
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="certificate">{{
                                                trans(
                                                    "course.add_course_course_certificate"
                                                )
                                            }}</label>
                                        <a :href="route('certificate-creator')" target="_blank">
                                            <i
                                                class="fas fa-plus ml-2 pointer"
                                                data-placement="top"
                                                data-toggle="tooltip"
                                                :title="trans('course.add_certificates_add')"
                                            ></i>
                                        </a>
                                        <select
                                            id="certificate"
                                            v-model="form.certificate"
                                            class="form-control"
                                            @change="courseChange"
                                        >
                                            <option value="0">{{
                                                    trans(
                                                        "course.add_course_select_certificate"
                                                    )
                                                }}
                                            </option>
                                            <option
                                                v-for="(certificate,
                                                id) in certificates"
                                                :value="certificate.id"
                                                :key="'cert-select-' + id"
                                            >{{ certificate.name }}
                                            </option
                                            >
                                        </select>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="show_certificate_when">
                                            {{ trans("course.add_course_show_certificate") }}
                                            <a href="#" @click.stop.prevent="updateStudentProgress" target="_blank">
                                                <i
                                                    class="fas fa-sync ml-2 pointer"
                                                    data-placement="top"
                                                    data-toggle="tooltip"
                                                    :title="trans('course.update_student_progress')"
                                                ></i>
                                            </a>
                                        </label>
                                        <select
                                            id="show_certificate_when"
                                            v-model="form.show_certificate_when"
                                            class="form-control"
                                            @change="courseChange"
                                        >
                                            <option
                                                v-for="(option,
                                                id) in showCertificateWhen"
                                                :key="'scoption' + id"
                                                :value="id"
                                            >{{ option }}
                                            </option
                                            >
                                        </select>
                                    </div>
                                </div>
<!--                                <div-->
<!--                                    v-if="showCertificateCreator"-->
<!--                                    id="course-certificate-creator"-->
<!--                                    class="mb-5 col-12"-->
<!--                                >-->
<!--                                    <certificate-->
<!--                                        :cid="form.id"-->
<!--                                        v-on:get-certificates-method="-->
<!--                                            updateCertificates-->
<!--                                        "-->
<!--                                    ></certificate>-->
<!--                                </div>-->
                                <div class="col-12">
                                    <div
                                        class="form-group"
                                        style="height: 100%"
                                    >
                                        <label for="courseFinishMessage">{{
                                                trans(
                                                    "course.finish_message_label"
                                                )
                                            }}</label>
                                        <textarea
                                            id="courseFinishMessage"
                                            v-model="form.courseFinishMessage"
                                            maxlength="1024"
                                            class="form-control"
                                            row="3"
                                            style="min-height: 135px; height: 80%"
                                            @change="courseChange"
                                            v-on:keyup="limitDescription"
                                        ></textarea>
                                    </div>
                                </div>
                                <div class="col-6 mb-3">
                                    <label for="courseType">{{
                                            trans("course.add_course_course_type")
                                        }}</label>
                                    <select
                                        id="courseType"
                                        v-model="form.free_course"
                                        class="form-control free-course-dropdown w-100"
                                        @change="courseChange"
                                    >
                                        <option value="0">{{
                                                trans("course.add_course_paid")
                                            }}
                                        </option>
                                        <option value="1">{{
                                                trans("course.add_course_free")
                                            }}
                                        </option>
                                    </select>
                                    <textarea id="url" class="d-none">{{
                                        url
                                    }}</textarea>
                                </div>
                                <div v-if="showAuthor" class="col-6">
                                    <label>{{
                                            trans("course.add_course_course_author")
                                        }}</label>
                                    <input
                                        :value="courseAuthor"
                                        class="form-control"
                                        readonly
                                        type="text"
                                    />
                                </div>
                                <div v-if="form.free_course" class="col-6">
                                    <label>{{
                                            trans("course.add_course_course_url")
                                        }}</label>
                                    <div>
                                        <button
                                            class="btn btn-success"
                                            type="button"
                                            @click="copyUrl"
                                        >
                                            {{
                                                trans(
                                                    "course.add_course_copy_free_url"
                                                )
                                            }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <a
                                class="btn btn-primary mt-2"
                                @click="showInformations = false"
                            >{{
                                    trans("course.add_course_hide_information")
                                }}</a
                            >
                        </div>
                        <div
                            v-if="showCoauthors"
                            class="border-bottom pb-3 mb-3"
                        >
                            <coauthors :cid="form.id"></coauthors>
                            <a
                                class="btn btn-primary mt-2"
                                @click="showCoauthors = false"
                            >{{
                                    trans("course.add_course_hide_coauthors")
                                }}</a
                            >
                        </div>
                    </template>
                    <div
                        id="alert-copy-url"
                        class="alert alert-success alert-dismissible fade show"
                        role="alert"
                    >
                        {{ trans("course.add_course_copy_url_message") }}
                        <button
                            aria-label="Close"
                            class="close"
                            data-dismiss="alert"
                            type="button"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <template v-if="showSection">
                        <div class="row">
                            <div class="col-10">
                                <h4>
                                    {{
                                        trans("messages.course_creator_levels")
                                    }}
                                </h4>
                                <small
                                    id="emailHelp"
                                    class="form-text text-muted"
                                >{{
                                        trans(
                                            "messages.course_creator_drag_and_drop_descriptions"
                                        )
                                    }}</small
                                >
                            </div>
                        </div>
                        <!--    :forceFallback=true :scroll-sensitivity="200" -->
                        <draggable
                            :list="list2"
                            :scroll="true"
                            :scroll-sensitivity="10"
                            :scroll-speed="2000"
                            :swapThreshold="0.5"
                            class="course-section-area"
                            group="people"
                            handle=".handle"
                            tag="div"
                            @change="change(false, true, $event)"
                            @start="startDrag"
                            @end="endDrag"
                        >
                            <div
                                v-for="(element, idx) in list2"
                                :key="'lesson' + idx"
                                :style="{'opacity': element?.parentDragging ? '50%' : '100%' }"
                            >
                                <template v-if="element.type == 'lesson'">
                                    <div
                                        v-if="element.deleted"
                                        class="removed-content text-center"
                                    >
                                     <div class="remove-restore-content-container">
                                        <h5 class="d-inline-block">
                                            {{
                                                trans(
                                                    "course.add_course_lesson_removed_msg"
                                                )
                                            }}
                                        </h5>
                                         <div class="delete-restore-button-container">
                                        <button
                                            class="btn btn-success delete-restore-buttons d-inline-block"
                                            type="button"
                                            @click="restoreLesson(idx)"
                                        >
                                            {{
                                                trans(
                                                    "course.add_course_restore"
                                                )
                                            }}
                                        </button>
                                        <button
                                            class="btn btn-danger delete-restore-buttons d-inline-block"
                                            type="button"
                                            @click="deletePermanently(idx)"
                                        >
                                            {{
                                                trans(
                                                    "course.add_course_delete_permanently"
                                                )
                                            }}
                                        </button>
                                        </div>
                                       </div>
                                    </div>
                                    <div
                                        v-else
                                        :id="
                                            'element-' +
                                                element.type +
                                                '-' +
                                                element.id
                                        "
                                        class="creator-block type-lesson"
                                    >
                                        <div class="creator-block-top">
                                            <div
                                                class="course-icon-wrap handle hover-image"
                                            >
                                                <img
                                                    :src="
                                                        '/images/drag-grey.png'
                                                    "
                                                    alt=""
                                                    class="inactive-icon"
                                                    loading="lazy"
                                                    style="opacity: 1;"
                                                />
                                                <img
                                                    :src="
                                                        '/images/drag-orange.png'
                                                    "
                                                    alt=""
                                                    class="active-icon"
                                                    loading="lazy"
                                                    style="opacity: 0;"
                                                />
                                            </div>
                                            <div class="text-field-wrap">
                                                <input
                                                    v-model="list2[idx].name"
                                                    :placeholder="
                                                        trans(
                                                            'forms.generic.placeholder.Lesson'
                                                        )
                                                    "
                                                    class="form-control chapter lesson w-input"
                                                    required=""
                                                    type="text"
                                                    maxlength="255"
                                                    @change="
                                                        save(list2[idx], idx)
                                                    "
                                                    @click="
                                                        openEditor(
                                                            element.id,
                                                            idx,
                                                            true
                                                        )
                                                    "
                                                    @focus="
                                                        focusInput(element, idx)
                                                    "
                                                />
                                            </div>
                                            <div
                                                class="course-icon-wrap mr hover-image"
                                                @click="
                                                    openEditor(element.id, idx)
                                                "
                                            >
                                                <img
                                                    :src="
                                                        '/images/svg-icons/marlms-build-lesson.svg'
                                                    "
                                                    alt=""
                                                    class="inactive-icon svg-with-hover"
                                                    :class="{'active': element.showEditor}"
                                                    loading="lazy"
                                                    style="opacity: 1;"
                                                />
                                            </div>
                                            <div
                                                class="course-icon-wrap mr hover-image"
                                            >
                                                <img
                                                    v-if="!element.hide"
                                                    :src="
                                                        '/images/svg-icons/marlms-eye-icon.svg'
                                                    "
                                                    alt=""
                                                    class="inactive-icon svg-with-hover"
                                                    loading="lazy"
                                                    @click="hideLesson(1, idx)"
                                                />
                                                <img
                                                    v-else
                                                    :src="
                                                        '/images/svg-icons/marlms-hidden-icon.svg'
                                                    "
                                                    alt=""
                                                    class="inactive-icon"
                                                    loading="lazy"
                                                    @click="hideLesson(0, idx)"
                                                />
                                            </div>

                                                    <div
                                                        class="course-icon-wrap mr"
                                                        tabindex="0"
                                                        @click.prevent="
                                                            openLessonTime(
                                                                idx,
                                                                element.id
                                                            )
                                                        "
                                                    >
                                                        <div
                                                            class="dropdown-icon-wrap mr"
                                                        >
                                                            <img
                                                                :src="
                                                                    '/images/svg-icons/marlms-time-duration.svg'
                                                                "
                                                                alt=""
                                                                class="inactive-icon svg-with-hover"
                                                                :class="{'active': element.showLessonTimeEditor}"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                    <a
                                                        :data-confirm-message="
                                                            trans(
                                                                'messages.remove_lesson_confirm_dialog_message'
                                                            )
                                                        "
                                                        :data-confirm-title="
                                                            trans(
                                                                'messages.remove_lesson_confirm_dialog_title'
                                                            )
                                                        "
                                                        class="delete"
                                                        tabindex="0"
                                                        @click="
                                                            removeSection(
                                                                idx,
                                                                $event
                                                            )
                                                        "
                                                    >
                                                        <div
                                                            class="course-icon-wrap"
                                                        >
                                                            <img
                                                                :src="
                                                                    '/images/svg-icons/marlms-delete-action.svg'
                                                                "
                                                                alt=""
                                                                class="svg-with-hover pb-2"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </a>
                                                    <!--                                                    <export-button-menu-->
                                                    <!--                                                        :exportTypes ="lessonExportTypes"-->
                                                    <!--                                                        :elementType ="element.type"-->
                                                    <!--                                                        :elementId="element.id"-->
                                                    <!--                                                        :buttonLabel = false-->
                                                    <!--                                                    />-->
                                        </div>
                                        <div
                                            v-if="element.showEditor"
                                            :id="'editor-' + element.id"
                                            class="creator-block-bottom "
                                        >
                                            <inline-editor
                                                :cid="form.id"
                                                :keep="course.default_keep"
                                                :lid="element.id"
                                                :sections="list2"
                                                :sid="idx"
                                                :type="'lesson'"
                                                @update-section-content="updateSectionContent"
                                                @update-content="updateBlocks"
                                            ></inline-editor>
                                        </div>
                                        <template
                                            v-if="element.showLessonTimeEditor"
                                        >
                                            <div
                                                class="creator-block-bottom time-duration"
                                                style="display: block;"
                                            >
                                                <div class="tab-link is-static">
                                                    <div
                                                        class="content-icon-wrap hover-image"
                                                    >
                                                        <img
                                                            :src="
                                                                '/images/svg-icons/marlms-time-duration.svg'
                                                            "
                                                            alt=""
                                                            class="inactive-icon svg-with-icon"
                                                            loading="lazy"
                                                        />
                                                    </div>
                                                    <div>
                                                        {{
                                                            trans(
                                                                "course.add_course_time_duration"
                                                            )
                                                        }}
                                                    </div>
                                                </div>
                                                <div
                                                    class="w-layout-grid time-duration-grid"
                                                >
                                                    <input
                                                        v-model="
                                                            element.lessonMinutes
                                                        "
                                                        class="form-control w-input"
                                                        type="text"
                                                        @change="
                                                            save(
                                                                list2[idx],
                                                                idx
                                                            )
                                                        "
                                                    />
                                                    <div>
                                                        {{
                                                            trans(
                                                                "course.add_course_minutes"
                                                            )
                                                        }}
                                                    </div>
                                                    <input
                                                        v-model="
                                                            element.lessonSeconds
                                                        "
                                                        class="form-control w-input"
                                                        type="text"
                                                        @change="
                                                            save(
                                                                list2[idx],
                                                                idx
                                                            )
                                                        "
                                                    />
                                                    <div>
                                                        {{
                                                            trans(
                                                                "course.add_course_seconds"
                                                            )
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>

                                    <div
                                        v-if="element.pageBreak"
                                        class="type-lesson"
                                    >
                                        <hr/>
                                    </div>
                                </template>
                                <template v-else-if="element.type == 'quiz'">
                                    <div
                                        v-if="element.deleted"
                                        class="removed-content text-center"
                                    >
                                      <div class="remove-restore-content-container">
                                        <h5 class="d-inline-block">
                                            {{
                                                trans(
                                                    "course.add_course_quiz_removed_msg"
                                                )
                                            }}
                                        </h5>
                                          <div class="delete-restore-button-container">
                                        <button
                                            class="btn btn-success delete-restore-buttons d-inline-block"
                                            type="button"
                                            @click="restoreLesson(idx)"
                                        >
                                            {{
                                                trans(
                                                    "course.add_course_restore"
                                                )
                                            }}
                                        </button>
                                        <button
                                            class="btn btn-danger delete-restore-buttons d-inline-block"
                                            type="button"
                                            @click="deletePermanently(idx)"
                                        >
                                            {{
                                                trans(
                                                    "course.add_course_delete_permanently"
                                                )
                                            }}
                                        </button>
                                        </div>
                                        </div>
                                    </div>
                                    <div
                                        v-else
                                        :id="
                                            'element-' +
                                                element.type +
                                                '-' +
                                                element.id
                                        "
                                        class="creator-block type-quiz"
                                    >
                                        <div class="creator-block-top">
                                            <div
                                                class="course-icon-wrap handle hover-image"
                                            >
                                                <img
                                                    :src="
                                                        '/images/drag-grey.png'
                                                    "
                                                    alt=""
                                                    class="inactive-icon"
                                                    loading="lazy"
                                                />
                                                <img
                                                    :src="
                                                        '/images/drag-orange.png'
                                                    "
                                                    alt=""
                                                    class="active-icon"
                                                    loading="lazy"
                                                    style="opacity: 0;"
                                                />
                                            </div>

                                            <div class="text-field-wrap">
                                                <input
                                                    v-model="list2[idx].name"
                                                    :class="{
                                                        essay:
                                                            element.quizType ===
                                                            'essay'
                                                    }"
                                                    :placeholder="
                                                        element.quizType
                                                            ? trans(
                                                                  'forms.generic.placeholder.' +
                                                                      element.quizType
                                                                          .charAt(
                                                                              0
                                                                          )
                                                                          .toUpperCase() +
                                                                      element.quizType.slice(
                                                                          1
                                                                      )
                                                              )
                                                            : ''
                                                    "
                                                    class="form-control chapter quiz w-input"
                                                    type="text"
                                                    maxlength="255"
                                                    @change="
                                                        save(list2[idx], idx)
                                                    "
                                                    @focus="
                                                        focusInput(
                                                            element,
                                                            idx
                                                        );
                                                        openQuiz(
                                                            element.qid,
                                                            idx,
                                                            true
                                                        );
                                                    "
                                                />
                                            </div>
                                            <div
                                                class="course-icon-wrap mr hover-image"
                                                @click="
                                                    openQuiz(element.qid, idx)
                                                "
                                            >
                                                <img
                                                    :src="
                                                        element.quizType ===
                                                        'essay'
                                                            ? '/images/svg-icons/marlms-build-essay.svg'
                                                            : '/images/svg-icons/marlms-build-quiz.svg'
                                                    "
                                                    alt=""
                                                    class="inactive-icon svg-with-hover"
                                                    :class="{'active': element.showQuiz}"
                                                    loading="lazy"
                                                    style="opacity: 1;"
                                                />
                                            </div>
                                            <div
                                                class="course-icon-wrap mr hover-image"
                                            >
                                                <img
                                                    v-if="!element.hide"
                                                    :src="
                                                        '/images/svg-icons/marlms-eye-icon.svg'
                                                    "
                                                    alt=""
                                                    class="inactive-icon svg-with-hover"
                                                    loading="lazy"
                                                    @click="hideLesson(1, idx)"
                                                />
                                                <img
                                                    v-else
                                                    :src="
                                                        '/images/svg-icons/marlms-hidden-icon.svg'
                                                    "
                                                    alt=""
                                                    class="inactive-icon"
                                                    loading="lazy"
                                                    @click="hideLesson(0, idx)"
                                                />
                                            </div>
                                            <a
                                                class="w-inline-block"
                                                tabindex="0"
                                                @click="
                                                    showQuizDescription(
                                                        element.qid,
                                                        idx
                                                    )
                                                "
                                            >
                                                <div
                                                    class="course-icon-wrap mr hover-image"
                                                >
                                                    <img
                                                        :src="
                                                            '/images/svg-icons/marlms-description-icon.svg'
                                                        "
                                                        alt=""
                                                        class="inactive-icon svg-with-hover"
                                                        :class="{'active': element.showQuizDescription}"
                                                        loading="lazy"
                                                    />
                                                </div>
                                            </a>
                                            <!--                                                    <a data-w-id="47881859-2355-350f-ab06-43a077925c0c" href="#" class="action-link w-inline-block" tabindex="0">-->
                                            <!--                                                        <div class="dropdown-icon-wrap mr hover-image"><img :src="'/images/marLMS-download.png'" loading="lazy" alt="" class="inactive-icon"><img :src="'/images/marLMS-download-orange.png'" loading="lazy" alt="" class="active-icon" style="opacity: 0;"></div>-->
                                            <!--                                                        <div>{{trans('course.add_course_html5_scorm')}}</div>-->
                                            <!--                                                    </a>-->
                                            <a
                                                :data-confirm-message="
                                                    trans(
                                                        'messages.remove_quiz_confirm_dialog_message'
                                                    )
                                                "
                                                :data-confirm-title="
                                                    trans(
                                                        'messages.remove_quiz_confirm_dialog_title'
                                                    )
                                                "
                                                class="delete w-inline-block"
                                                tabindex="0"
                                                @click="
                                                    removeSection(
                                                        idx,
                                                        $event
                                                    )
                                                "
                                            >
                                                <div
                                                    class="course-icon-wrap"
                                                >
                                                    <img
                                                        :src="
                                                            '/images/svg-icons/marlms-delete-action.svg'
                                                        "
                                                        alt=""
                                                        class="inactive-icon svg-with-hover"
                                                        loading="lazy"
                                                    />
                                                </div>
                                            </a>
                                        </div>
                                        <div
                                            v-if="element.showQuiz"
                                            :id="'quiz-' + element.id"
                                        >
                                            <course-quiz-creator
                                                :q-name="list2[idx].name"
                                                :qId="quizId"
                                                :sections="list2"
                                                :show-description-block="
                                                    element.showQuizDescription
                                                "
                                                :sid="idx"
                                                @update-blocks="updateBlocks"
                                            ></course-quiz-creator>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div
                                        :id="
                                            'element-' +
                                                element.type +
                                                '-' +
                                                element.id
                                        "
                                        :class="'type-' + element.type"
                                        class="creator-block"
                                    >
                                        <div class="creator-block-top">
                                            <div
                                                class="course-icon-wrap handle hover-image"
                                            >
                                                <img
                                                    :src="
                                                        '/images/drag-grey.png'
                                                    "
                                                    alt=""
                                                    class="inactive-icon"
                                                    loading="lazy"
                                                />
                                                <img
                                                    :src="
                                                        '/images/drag-orange.png'
                                                    "
                                                    alt=""
                                                    class="active-icon"
                                                    loading="lazy"
                                                    style="opacity: 0;"
                                                />
                                            </div>
                                            <div class="text-field-wrap">
                                                <input
                                                    v-model="list2[idx].name"
                                                    :placeholder="
                                                        trans(
                                                            'forms.generic.placeholder.Chapter'
                                                        )
                                                    "
                                                    class="form-control chapter w-input"
                                                    type="text"
                                                    maxlength="255"
                                                    @change="
                                                        save(list2[idx], idx)
                                                    "
                                                    @focus="
                                                        focusInput(element, idx)
                                                    "
                                                />
                                            </div>
                                            <div
                                                class="course-icon-wrap mr hover-image"
                                                @click="
                                                    openDescription(
                                                        idx,
                                                        element.id,
                                                        'description'
                                                    )
                                                "
                                            >
                                                <img
                                                    :src="
                                                        '/images/svg-icons/marlms-build-lesson.svg'
                                                    "
                                                    alt=""
                                                    class="inactive-icon svg-with-hover"
                                                    :class="{'active': element.showDescriptionEditor}"
                                                    loading="lazy"
                                                />
                                            </div>
                                            <div
                                                class="course-icon-wrap mr hover-image"
                                            >
                                                <img
                                                    v-if="!element.hide"
                                                    :src="
                                                        '/images/svg-icons/marlms-eye-icon.svg'
                                                    "
                                                    alt=""
                                                    class="inactive-icon svg-with-hover"
                                                    loading="lazy"
                                                    @click="hideLesson(1, idx)"
                                                />
                                                <img
                                                    v-else
                                                    :src="
                                                        '/images/svg-icons/marlms-hidden-icon.svg'
                                                    "
                                                    alt=""
                                                    class="inactive-icon"
                                                    loading="lazy"
                                                    @click="hideLesson(0, idx)"
                                                />
                                            </div>
                                            <div
                                                class="course-icon-wrap mr hover-image"
                                                @click="
                                                    openDescription(
                                                        idx,
                                                        element.id,
                                                        'goal'
                                                    )
                                                "
                                            >
                                                <img
                                                    :src="
                                                        '/images/svg-icons/marlms-target.svg'
                                                    "
                                                    alt=""
                                                    class="inactive-icon svg-with-hover"
                                                    :class="{'active': element.showGoalEditor}"
                                                    loading="lazy"
                                                />
                                            </div>
                                                <a
                                                    v-if="
                                                        element.type !=
                                                            1
                                                    "
                                                    class="w-inline-block course-icon-wrap mr"
                                                    tabindex="0"
                                                    @click="
                                                        levelUp(
                                                            idx,
                                                            element.type
                                                        )
                                                    "
                                                >
                                                    <div
                                                        class="dropdown-icon-wrap"
                                                    >
                                                        <img
                                                            :src="
                                                                '/images/svg-icons/marlms-arrow-up.svg'
                                                            "
                                                            alt=""
                                                            class="inactive-icon svg-with-hover"
                                                            loading="lazy"
                                                        />
                                                    </div>
                                                </a>
                                                <a
                                                    v-if="
                                                        element.type !=
                                                            4 &&
                                                            idx != 0 &&
                                                            checkLevel(
                                                                idx
                                                            )
                                                    "
                                                    class="w-inline-block"
                                                    tabindex="0"
                                                    @click="
                                                        levelDown(
                                                            idx,
                                                            element.type
                                                        )
                                                    "
                                                >
                                                    <div
                                                        class="course-icon-wrap mr"
                                                    >
                                                        <img
                                                            :src="
                                                                '/images/svg-icons/marlms-arrow-down.svg'
                                                            "
                                                            alt=""
                                                            class="inactive-icon svg-with-hover"
                                                            loading="lazy"
                                                        />
                                                    </div>
                                                </a>
                                                <a
                                                    :data-confirm-message="
                                                        trans(
                                                            'messages.remove_section_confirm_dialog_message'
                                                        )
                                                    "
                                                    :data-confirm-title="
                                                        trans(
                                                            'messages.remove_section_confirm_dialog_title'
                                                        )
                                                    "
                                                    class="delete w-inline-block"
                                                    tabindex="0"
                                                    @click="
                                                        removeSection(
                                                            idx,
                                                            $event
                                                        )
                                                    "
                                                >
                                                    <div
                                                        class="course-icon-wrap"
                                                    >
                                                        <img
                                                            :src="
                                                                '/images/svg-icons/marlms-delete-action.svg'
                                                            "
                                                            alt=""
                                                            class="svg-with-hover pb-2"
                                                            loading="lazy"
                                                        />
                                                    </div>
                                                </a>
                                        </div>
                                        <template v-if="element.showGoalEditor">
                                            <div
                                                class="creator-block-bottom goal"
                                            >
                                                <div
                                                    v-for="(goal,
                                                    idg) in element.goalBlocks"
                                                    :key="'gbm' + idx"
                                                    class="flex content-builder-block"
                                                >
                                                    <input
                                                        v-model="
                                                            list2[idx]
                                                                .goalBlocks[idg]
                                                        "
                                                        :placeholder="
                                                            trans(
                                                                'forms.generic.placeholder.enter_goal'
                                                            )
                                                        "
                                                        class="form-control"
                                                        type="text"
                                                        maxlength="255"
                                                        @change="
                                                            save(
                                                                list2[idx],
                                                                idx,
                                                                true,
                                                                false
                                                            )
                                                        "
                                                    />
                                                    <div
                                                        class="action-icon-wrap"
                                                    >
                                                        <a
                                                            :data-confirm-message="
                                                                trans(
                                                                    'messages.remove_section_goal_confirm_dialog_message'
                                                                )
                                                            "
                                                            :data-confirm-title="
                                                                trans(
                                                                    'messages.remove_section_goal_confirm_dialog_title'
                                                                )
                                                            "
                                                            class="action-link delete width-auto w-inline-block"
                                                            @click="
                                                                removeGoal(
                                                                    idx,
                                                                    idg,
                                                                    $event
                                                                )
                                                            "
                                                        >
                                                            <div
                                                                class="dropdown-icon-wrap"
                                                            >
                                                                <img
                                                                    :src="
                                                                        '/images/svg-icons/marlms-delete-action.svg'
                                                                    "
                                                                    alt=""
                                                                    class="inactive-icon svg-with-hover"
                                                                    loading="lazy"
                                                                    style="opacity: 1;"
                                                                />
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                                <a
                                                    class="course-text-link add"
                                                    @click="addGoal(idx)"
                                                >{{
                                                        trans(
                                                            "course.add_course_add_goals"
                                                        )
                                                    }}</a
                                                >
                                            </div>
                                        </template>
                                        <template
                                            v-if="element.showDescriptionEditor"
                                        >
                                            <div class="creator-block-bottom">
                                                <inline-editor
                                                    :key="Math.random()"
                                                    :cid="form.id"
                                                    :keep="course.default_keep"
                                                    :sections="list2"
                                                    :sid="idx"
                                                    :type="'description'"
                                                    v-on:description-method="updateDescription"
                                                    @update-section-content="updateSectionContent"
                                                ></inline-editor>
                                            </div>
                                        </template>
                                    </div>
                                </template>
                            </div>
                        </draggable>
                    </template>
                </form>
            </div>
            <div class="side-content right side-right-initial-state">
                <div class="fixed-parent goals">
                    <div class="fixed pr-2">
                        <template v-if="showSection">
                            <div class="section-title-wrap">
                                <h2 class="section-title">
                                    {{ trans("course.add_course_goals") }}
                                </h2>
                            </div>
                            <div class="row mb-3">
                                <div class="col-12">
                                    <ol v-if="hasGoals" class="goals-list">
                                        <template
                                            v-for="(element, idx1) in list2"
                                            v-if="element.goalBlocks"
                                        >
                                            <li
                                                v-for="(goal,
                                                idx) in element.goalBlocks"
                                                v-if="goal && goal != ''"
                                                :key="'gbgoal' + idx1 + idx"
                                                class="list-item no-box"
                                            >
                                                <div
                                                    class="pl-0 pr-0 mt-2 text-break"
                                                    v-html="goal"
                                                ></div>
                                            </li>
                                        </template>
                                    </ol>
                                    <div v-else>
                                        {{
                                            trans(
                                                "course.add_course_no_goals_msg"
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="fixed-parent quizzes">
                    <div class="fixed pr-2">
                        <template v-if="showSection">
                            <div class="section-title-wrap">
                                <h2 class="section-title">
                                    {{
                                        trans(
                                            "messages.course_creator_existing_quizzes"
                                        )
                                    }}
                                </h2>
                            </div>
                            <div class="form-inline custom-search-quiz">
                                <input
                                    v-model="quizSearch"
                                    :placeholder="
                                        trans('course')['listing.search']
                                    "
                                    aria-label="Search"
                                    class="form-control create-course-search-custom search"
                                    type="search"
                                    @input="searchExistingQuizzes"
                                />
                            </div>
                            <div class="row mb-3">
                                <div class="col-12">
                                    <draggable
                                        :clone="cloneQuiz"
                                        :group="{
                                            name: 'people',
                                            pull: 'clone',
                                            put: false
                                        }"
                                        :sort="false"
                                        :list="existingQuizzes"
                                        class="mt-3 existing-quizes-list"
                                        tag="div"
                                    >
                                        <div
                                            v-for="(element,
                                            idx) in existingQuizzes"
                                            :key="'quiz-' + idx"
                                            class="list-item no-box pointer"
                                        >
                                            <label
                                                class="course-text-link pointer"
                                            >{{ element.name }}</label
                                            >
                                        </div>
                                    </draggable>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showAddCategoryModal">
            <add-category-modal
                :categories="categories"
                v-on:update-categories="updateCategories"
            ></add-category-modal>
        </div>
        <world-clocks-modal
            v-if="showWorldClocks"
            @modal-closed="showWorldClocks = false"
        ></world-clocks-modal>
    </div>
</template>

<script>
function offsetAnchor() {
    if (location.hash.length !== 0) {
        window.scrollTo(window.scrollX, window.scrollY - 100);
    }
}

// Captures click events of all a elements with href starting with #
$(document).on("click", 'a[href^="#"]', function (event) {
    // Click events are captured before hashchanges. Timeout
    // causes offsetAnchor to be called after the page jump.
    window.setTimeout(function () {
        offsetAnchor();
    }, 0);
});

// Set the offset when entering page with hash present in the url
window.setTimeout(offsetAnchor, 0);
import draggable from "vuedraggable";
// import nestedDraggable from "./FormBuilder/NestedDraggable";
// import UploadAdapter from "./UploadAdapter";
import WorldClocksModal from "./CourseParts/WorldClocksModal";
import WorldClock from "./CourseParts/WorldClock";

let idSection = 1;
export default {
    name: "nested-example",
    display: "Nested",
    order: 15,
    components: {
        draggable,
        // nestedDraggable,
        WorldClock,
        WorldClocksModal
    },
    props: {
        newCourseRoute: String,
        canExport: Boolean,
        currentUserId: Number,
        editToken: String,
    },
    watch: {
        descriptionDone: function (newVal, oldVal) {
            if (newVal === true) {
                this.courseStudent();
            }
        },
        quizDone: function (newVal, oldVal) {
        }
    },
    computed: {
        showAuthor() {
            return this.currentUserId !== this.course.user_id;
        },
        courseAuthor() {
            return (
                this.course.user.first_name + " " + this.course.user.last_name
            );
        },
        showImage() {
            return this.course.image !== null;
        },
        courseCategory: {
            get() {
                let courseCat = this.form.category;
                return this.categories.filter(cat => cat.id === courseCat)
                    .length
                    ? this.form.category
                    : 0;
            },
            set(val) {
                this.form.category = val;
            }
        }
    },
    created() {
        const url = window.location.pathname;
        let id = parseInt(url.substring(url.lastIndexOf("/") + 1));
        if (id && Number.isInteger(id)) {
            this.form.id = id;
            this.getCourse(true);
        }
        this.getExistingQuizzes();
        let wentAway = false;
        const self = this;

        window.onfocus = async function () {
            async function shouldReload() {
                if (!self.form.id) {
                    return false;
                }
                return axios
                    .get('/api/get-course-edit-token/' + self.form.id)
                    .then(response => {
                        return response.data.edit_token !== self.editToken;
                    })
                    .catch(err => {
                        self.$data.loader = false;
                    });
            }

            if (wentAway && await shouldReload()) {
                wentAway = false;
                self.$swal
                    .fire({
                        title: window.trans.course.edited_in_another_browser,
                        icon: "warning",
                        html: window.trans.course.open_or_cancel,
                        showCloseButton: true,
                        showCancelButton: true,
                        reverseButtons: true,
                        focusConfirm: false,
                        confirmButtonColor: 'red',
                        confirmButtonText: window.trans.messages.Yes,
                        cancelButtonText: window.trans.messages.No
                    })
                    .then((result) => {
                        if (result.isConfirmed) {
                            window.location.reload();
                        } else {
                            window.location.href = self.url + "/admin/courses-management";
                        }
                    });

            }
        };

        window.onblur = function () {
            wentAway = true;
        };
    },
    data: function () {
        return {
            url: window.location.protocol + "//" + window.location.host,
            reload: 0,
            loader: false,
            showSection: false,
            showCoauthors: false,
            showInformations: false,
            quizId: 0,
            courseDescriptionLenght: null,
            courseDescriptionType: null,
            goalActive: false,
            courseExportTypes: ["marlms", "html5-scorm"], //'pdf','html5-scorm', 'moodle'
            lessonExportTypes: ["html5-scorm"],
            hasGoals: false,
            showAddCategoryModal: false,
            showCertificateCreator: false,
            contentBlocks: [
                {
                    name: "Chapter",
                    id: 1,
                    type: "1",
                    essay: false,
                    image: "chapter-grey.png",
                    image_hover: "chapter-orange.png"
                },
                {
                    name: "Lesson",
                    id: 1,
                    type: "lesson",
                    essay: false,
                    lessonType: "content",
                    image: "lesson-grey.png",
                    image_hover: "lesson_orange.png"
                },
                {
                    name: "Quiz",
                    id: 1,
                    type: "quiz",
                    essay: false,
                    image: "quiz-grey.png",
                    image_hover: "quiz-orange.png"
                },
                {
                    name: "Essay",
                    id: 1,
                    type: "quiz",
                    essay: true,
                    image: "essay-grey.png",
                    image_hover: "essay-orange.png"
                }
            ],
            pageBreak: [{name: "Page Break", id: 1, type: "pageBreak"}],
            existingQuizzes: [],
            list2: [],
            allSections: [],
            categories: [],
            certificates: [],
            showCertificateWhen: {
                1: trans.course.creator.completionOptions['No Certificate'],
                2: trans.course.creator.completionOptions["Complete all Lessons"],
                3: trans.course.creator.completionOptions["Pass the Final Exam"],
                4: trans.course.creator.completionOptions["Pass the Quizzes"],
                5: trans.course.creator.completionOptions["Finish all Lessons and pass the Final Exam"],
                6: trans.course.creator.completionOptions["Finish all Lessons and pass Quizzes"]
            },
            map: [],
            course: [],
            quizSearch: "",
            form: {
                id: null,
                change: false,
                exit: false,
                free_course: 0,
                category: 0,
                certificate: 0,
                show_certificate_when: 0,
                courseName: "",
                courseDescription: "",
                courseFinishMessage: '',
                sections: []
            },
            modalId: null,
            showWorldClocks: false,
        };
    },
    mounted() {
        this.getCategories();
        // this.getLayoutSettings();
        this.getCertificates();
        if (this.form.id) {
            $(".exposed-action.preview").attr(
                "href",
                "/course-preview/" + this.form.id
            );
        }
    },
    methods: {
        log: function (evt) {
            window.console.log(evt);
        },
        // uploader(editor) {
        //     editor.plugins.get(
        //         "FileRepository"
        //     ).createUploadAdapter = loader => {
        //         return new UploadAdapter(loader);
        //     };
        // },
        change: function (editor = false, change = false, event = false) {
            let preview;
            let self = this;
            let data = [];
            this.loader = true;
            this.form.change = change;

            let temp = [];
            let tempData = [];

            // this code add children of moved element in a temp array;
            if (event && typeof event.moved != "undefined") {
                this.list2.forEach(function (section, key) {
                    if (key == event.moved.oldIndex) {
                        let moved = self.list2[event.moved.newIndex];
                        let newIdx = event.moved.newIndex;
                        let oldIdx = event.moved.oldIndex;

                        for (
                            let i = oldIdx > newIdx ? oldIdx + 1 : oldIdx;
                            i < self.list2.length;
                            i++
                        ) {
                            if (
                                self.list2[i].type == self.list2[newIdx].type ||
                                (["lesson", "quiz"].includes(
                                        self.list2[i].type
                                    ) &&
                                    ["lesson", "quiz"].includes(
                                        self.list2[newIdx].type
                                    ))
                            ) {
                                break;
                            }
                            if (
                                ["lesson", "quiz"].includes(
                                    self.list2[i].type
                                ) ||
                                self.list2[i].type > self.list2[newIdx].type
                            ) {
                                tempData.push({
                                    id: self.list2[i].id,
                                    type: self.list2[i].type,
                                    qid: self.list2[i].qid,
                                    clone: self.list2[i].clone
                                });
                                temp.push(i);
                            }
                        }
                    }
                });
            }

            this.list2.forEach(function (section, key) {
                if (!temp.includes(key)) {
                    data.push({
                        id: section.id,
                        type: section.type,
                        qid: section.qid,
                        clone: section.clone,
                        deleted: section.deleted,
                        essay: section.essay
                    });
                }
                // this code add children of moved element in main array;
                if (
                    event &&
                    typeof event.moved != "undefined" &&
                    key == event.moved.newIndex
                ) {
                    tempData.forEach(function (t) {
                        data.push({
                            id: t.id,
                            type: t.type,
                            qid: t.qid,
                            clone: t.clone,
                            essay: t.essay
                        });
                    });
                }
            });

            let $end = "/api/save-course";

            this.form.sections = [];
            this.form.sections.push(data);

            axios
                .post($end, this.form)
                .then(response => {
                    if (typeof response.data.redirect != "undefined") {
                        window.location.href = response.data.redirect;
                    }
                    this.getCourse();
                    self.getExistingQuizzes();
                    if (editor) {
                        $("#editor-" + editor).toggle();
                    }
                    self.loader = false;
                })
                .catch(err => {
                    self.$data.loader = false;
                });
        },
        saveOnNext: function () {
            // auto add chapter
            if (!this.form.sections.length) {
                this.form.sections.push({
                    id: 0,
                    type: 1,
                    qid: undefined,
                    clone: undefined,
                    deleted: undefined,
                    essay: 1,
                });
            }

            axios.post('/api/save-course', this.form)
                .then(response => {
                    if (typeof response.data.redirect != "undefined") {
                        window.location.href = response.data.redirect;
                    }
                });
        },
        save: function (data, idx = false, goal = false, reload = false) {
            if (goal) {
                this.hasGoals = true;
            }
            data.course_id = this.course.id;
            let $end = "/api/save-data";

            axios
                .post($end, data)
                .then(response => {
                    if (reload) {
                        this.getCourse(true);
                    } else {
                        this.updateCourseMap();
                    }
                })
                .catch(err => {
                    this.$data.loader = false;
                });
        },
        courseChange: function () {
            if (this.form.courseName != "") {
                this.showSection = true;
            }

            let data = {
                id: this.form.id,
                name: this.form.courseName,
                category: this.form.category,
                certificate: this.form.certificate,
                show_certificate_when: this.form.show_certificate_when,
                free_course: this.form.free_course,
                published: this.form.published,
                description: this.form.courseDescription,
                finish_message: this.form.courseFinishMessage,
                type: "course"
            };

            if (this.form.id) {
                this.save(data);
                this.$forceUpdate();
            }
        },
        cloneSection({id, type, essay}) {
            return {
                id: 0,
                name: "",
                description: "",
                type: type,
                essay: essay
            };
        },
        cloneQuiz({id, qid, name}) {
            return {
                id: id,
                qid: qid,
                name: '',
                description: "",
                type: "quiz",
                clone: true
            };
        },
        searchExistingQuizzes: function () {
            if (
                this.existingQuizzes.length < 1000 &&
                (this.quizSearch.length >= 2 || this.quizSearch.length === 0)
            ) {
                this.getExistingQuizzes();
            }
        },
        getExistingQuizzes: function () {
            let $end = "/api/get-quizzes-api/";
            let self = this;
            axios
                .get($end, {params: {search: this.quizSearch}})
                .then(function (response) {
                    response = response.data;
                    self.existingQuizzes = [];

                    response.forEach(function (quiz) {
                        let data = {
                            id: 0,
                            qid: quiz.id,
                            name: quiz.name
                                ? quiz.name
                                : trans.course.untitled[quiz.quiz_type],
                            description: quiz.description
                                ? quiz.description
                                : "",
                            type: "quiz"
                        };
                        self.existingQuizzes.push(data);
                    });
                })
                .catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
        },
        getCourse: function (deleteLeson = false) {
            setTimeout(function () {
                $('[data-toggle="tooltip"]').tooltip("hide");
            }, 50);
            if (!this.form.id) {
                return;
            }
            this.loader = true;
            let $end = "/api/get-course-api/" + this.form.id;
            let self = this;

            axios
                .get($end)
                .then(function (response) {
                    response = response.data;
                    self.token = response.token;
                    let course = response.course;

                    self.showSection = true;

                    self.form.courseName = course.name;
                    self.form.published = course.published;
                    self.form.category = course.category_id
                        ? course.category_id
                        : 0;
                    self.form.certificate = course.certificate_id
                        ? course.certificate_id
                        : 0;
                    self.form.show_certificate_when = course.show_certificate_when
                        ? course.show_certificate_when
                        : 0;
                    self.form.free_course = course.free_course
                        ? course.free_course
                        : 0;
                    self.form.courseDescription = course.description;
                    self.form.courseFinishMessage = course.finish_message;

                    self.list2 = [];

                    self.course = course;
                    if (self.course.library) {
                        self.course.image =
                            "/library/file/" +
                            self.course.library.hash +
                            "?token=" +
                            self.token;
                    }
                    if (self.course.library && self.course.library != "") {
                        $(".image-preview").css("display", "block");
                    }

                    let idxp;
                    self.map = [];

                    self.course.sections.forEach(function (section, key) {
                        if (section.section_type == 1) {
                            section.type = 1;
                            section.children = [];

                            section.lessons.forEach(function (lesson) {
                                lesson.type =
                                    lesson.type == "quiz" ? "quiz" : "lesson";
                                section.children.push(lesson);
                            });
                            self.map.push(section);
                            idxp = self.map.length - 1;
                        }
                        if ([2, 3, 4].includes(section.section_type)) {
                            section.type = section.section_type;
                            self.map[idxp].children.push(section);

                            section.lessons.forEach(function (lesson) {
                                lesson.type =
                                    lesson.type == "quiz" ? "quiz" : "lesson";
                                self.map[idxp].children.push(lesson);
                            });
                        }
                        let data = {
                            name: section.name,
                            hide: section.hide,
                            description: section.description
                                ? section.description
                                : "<h5>Description</h5>",
                            descriptionBlocks: section.description_blocks,
                            goal: section.goal ? section.goal : "",
                            goalBlocks: section.goal_blocks
                                ? JSON.parse(section.goal_blocks)
                                : [""],
                            id: section.id,
                            type: section.section_type,
                            children: section.pivot,
                            showGoalEditor: false,
                            showDescriptionEditor: false
                        };

                        if (
                            section.goal_blocks &&
                            JSON.parse(section.goal_blocks)[0]
                        ) {
                            self.hasGoals = true;
                        }
                        self.list2.push(data);
                        section.lessons.forEach(function (lesson) {
                            let data = {
                                name: lesson.name,
                                description: lesson.description
                                    ? lesson.description
                                    : "",
                                content:
                                    lesson.type == "quiz"
                                        ? lesson.quiz.content
                                        : lesson.content,
                                id: lesson.id,
                                type: lesson.type == "quiz" ? "quiz" : "lesson",
                                quizType:
                                    lesson.type == "quiz"
                                        ? lesson.quiz.quiz_type
                                        : "",
                                showEditor: false,
                                showQuiz: false,
                                showQuizDescription: false,
                                showLessonTimeEditor: false,
                                lessonMinutes: lesson.minutes,
                                lessonSeconds: lesson.seconds,
                                pageBreak: lesson.page_break,
                                hide:
                                    lesson.type == "quiz"
                                        ? lesson.quiz.hide
                                        : lesson.hide,
                                deleted: lesson.deleted,
                                qid: lesson.quiz_id
                            };

                            if (
                                (!data.name || !data.name.length) &&
                                lesson.type === "quiz"
                            ) {
                                data.name = lesson.quiz.name;
                            }

                            self.list2.push(data);

                            // if (deleteLeson && lesson.deleted) {
                            //     self.removeData(data);
                            // } else {
                            //     self.list2.push(data);
                            // }
                        });
                    });
                    setTimeout(function () {
                        $('[data-toggle="tooltip"]').tooltip();
                    }, 100);
                    self.loader = false;
                })
                .catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
        },
        updateCourseMap: function () {
            setTimeout(function () {
                $('[data-toggle="tooltip"]').tooltip("hide");
            }, 50);
            if (!this.form.id) {
                return;
            }
            this.loader = true;
            let $end = "/api/get-course-api/" + this.form.id;
            let self = this;

            axios
                .get($end)
                .then(function (response) {
                    response = response.data;
                    self.token = response.token;
                    let course = response.course;

                    let idxp;
                    self.map = [];

                    course.sections.forEach(function (section, key) {
                        if (section.section_type == 1) {
                            section.type = 1;
                            section.children = [];

                            section.lessons.forEach(function (lesson) {
                                lesson.type =
                                    lesson.type == "quiz" ? "quiz" : "lesson";
                                section.children.push(lesson);
                            });
                            self.map.push(section);
                            idxp = self.map.length - 1;
                        }
                        if ([2, 3, 4].includes(section.section_type)) {
                            section.type = section.section_type;
                            self.map[idxp].children.push(section);

                            section.lessons.forEach(function (lesson) {
                                lesson.type =
                                    lesson.type == "quiz" ? "quiz" : "lesson";
                                self.map[idxp].children.push(lesson);
                            });
                        }
                    });
                    setTimeout(function () {
                        $('[data-toggle="tooltip"]').tooltip();
                    }, 100);
                    self.loader = false;
                })
                .catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
        },
        getCategories: function () {
            let $end = "/api/categories-api/";
            let self = this;
            axios
                .get($end)
                .then(function (res) {
                    let response = res.data;
                    self.categories = response;
                })
                .catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
        },
        deleteCourse: function (event) {
            this.$swal
                .fire({
                    title: event.currentTarget.getAttribute(
                        "data-confirm-title"
                    ),
                    icon: "warning",
                    html: event.currentTarget.getAttribute(
                        "data-confirm-message"
                    ),
                    showCloseButton: true,
                    showCancelButton: true,
                    reverseButtons: true,
                    focusConfirm: false,
                    confirmButtonText: window.trans.messages.Yes,
                    cancelButtonText: window.trans.messages.No
                })
                .then(result => {
                    if (result.value) {
                        axios
                            .get("/delete-course/" + this.form.id, {
                                method: "delete"
                            })
                            .then(response => {
                                response = response.data;
                                if (response.result === "success") {
                                    window.location.href =
                                        "/courses-management";
                                }
                            })
                            .catch(err => {
                                console.log(err);
                                this.$data.loader = false;
                            });
                    }
                });
        },
        removeSection(id, event) {
            let self = this;
            let title = event.currentTarget.getAttribute(
                "data-confirm-title"
            );
            let html = event.currentTarget.getAttribute(
                "data-confirm-message"
            )
            this.$swal
                .fire({
                    title,
                    icon: "warning",
                    html,
                    showCloseButton: true,
                    showCancelButton: true,
                    reverseButtons: true,
                    focusConfirm: false,
                    confirmButtonText: window.trans.messages.Yes,
                    cancelButtonText: window.trans.messages.No
                })
                .then(result => {
                    if (result.value) {
                        if (
                            this.list2[id].type == "lesson" ||
                            this.list2[id].type == "quiz"
                        ) {
                            this.list2[id].deleted = true;
                            self.change(false, true);

                            $(
                                "#creator-map-" +
                                this.list2[id].type +
                                "-" +
                                this.list2[id].id
                            ).addClass("hide-tree-section");
                        } else {
                            this.$swal
                                .fire({
                                    title: trans.course.delete.are_you_sure_title,
                                    icon: "question",
                                    html: trans.course.delete.are_you_sure_html,
                                    showCloseButton: true,
                                    showCancelButton: true,
                                    reverseButtons: true,
                                    focusConfirm: false,
                                    confirmButtonColor: 'red',
                                    confirmButtonText: window.trans.messages.Yes,
                                    cancelButtonText: window.trans.messages.No
                                })
                                .then(result => {
                                    if (result.value) {
                                        this.removeData(this.list2[id]);
                                    }
                                })
                        }
                    }
                });
        },
        removeData(data) {
            let $end = "/api/remove-course-sections";

            data.course_id = this.form.id;

            axios
                .post($end, data)
                .then(response => {
                    this.getCourse();
                    this.getExistingQuizzes();
                })
                .catch(err => {
                    this.$data.loader = false;
                });
        },
        openEditor(id, idx, onlyOpen = false) {
            if (onlyOpen) {
                this.list2[idx].showEditor = true;
                this.$forceUpdate();
                return;
            }

            if (this.list2[idx].showEditor) {
                this.list2[idx].showEditor = false;
                //this.getCourse();
            } else {
                this.list2[idx].showEditor = true;
            }
            this.$forceUpdate();
        },
        openMap: function (element) {
            setTimeout(function () {
                $("#element-" + element.type + "-" + element.id)
                    .find("input:first")
                    .focus();
            }, 100);
        },
        expandMap: function(event, element) {
            // if (element.type!=1 || !element.children.length) {
            //     return;
            // }
            // console.log(element)
            let id = element.id;
            let child =  $('.children-'+id);
            if($(child).css('display') == 'none'){
                $('.map-icon-'+id).addClass('rotate-icon');
            }else{
                $('.map-icon-'+id).removeClass('rotate-icon');
            }
            $(child).toggle();
        },
        addLesson: function (id) {
            let data = {
                name: "",
                content: "",
                id: 0,
                type: "lesson"
            };

            this.list2.splice(id + 1, 0, data);
            this.change();
        },
        addQuiz: function (id) {
            let data = {
                name: "",
                content: "",
                id: 0,
                type: "quiz"
            };

            this.list2.splice(id + 1, 0, data);
            this.change();
        },
        openQuiz(id, idx, keepOpen) {
            this.quizId = id;
            if (this.list2[idx].showQuiz && !keepOpen) {
                this.list2[idx].showQuiz = false;
                this.list2[idx].showQuizDescription = false;
            } else {
                this.list2[idx].showQuiz = true;
                this.list2[idx].showQuizDescription = true;
            }
            this.$forceUpdate();
        },
        // closeModal() {
        //     this.quizId = 0;
        //     this.getExistingQuizzes();
        //     this.getCourse();
        //     $('#quizModal').modal('hide')
        // },
        // getLayoutSettings: function () {
        //     let $end = "/api/get-layout-settings/1";
        //     let self = this;
        //     axios
        //         .get($end)
        //         .then(function (res) {
        //             self.courseDescriptionLenght =
        //                 res.data.course_description_lenght;
        //             self.courseDescriptionType =
        //                 res.data.course_description_type;
        //         })
        //         .catch(err => {
        //             console.log(err);
        //             this.$data.loader = false;
        //         });
        // },
        limitDescription: function () {
            if (this.courseDescriptionType == "words") {
                let words = this.form.courseDescription.match(/\S+/g).length;

                if (words > this.courseDescriptionLenght) {
                    let trimmed = this.form.courseDescription
                        .split(/\s+/, 10)
                        .join(" ");
                    this.form.courseDescription = trimmed + " ";
                }
            }
        },
        openDescription: function (idx, id, type) {
            if (type == "description") {
                this.list2[idx].showGoalEditor = false;
                if (this.list2[idx].showDescriptionEditor) {
                    this.list2[idx].showDescriptionEditor = false;
                } else {
                    this.list2[idx].showDescriptionEditor = true;
                }
                if ($("#description-link-" + id).hasClass("active")) {
                    $("#description-link-" + id).removeClass("active");
                } else {
                    $("#description-link-" + id).addClass("active");
                    $("#goal-link-" + id).removeClass("active");
                }
            } else {
                setTimeout(function () {
                    $('[data-toggle="tooltip"]').tooltip();
                }, 100);
                this.list2[idx].showDescriptionEditor = false;
                if (this.list2[idx].showGoalEditor) {
                    this.list2[idx].showGoalEditor = false;
                } else {
                    this.list2[idx].showGoalEditor = true;
                }
                if ($("#goal-link-" + id).hasClass("active")) {
                    $("#goal-link-" + id).removeClass("active");
                } else {
                    $("#goal-link-" + id).addClass("active");
                    $("#description-link-" + id).removeClass("active");
                }
            }
            this.$forceUpdate();
        },
        openLessonTime: function (idx, id) {
            this.list2[idx].showLessonTimeEditor = !this.list2[idx].showLessonTimeEditor;
            this.$forceUpdate();
        },
        focusInput: function (element, idx) {
            $(".creator-map").removeClass("active");
            $("#creator-map-" + element.type + "-" + element.id).addClass(
                "active"
            );
            this.goalActive = idx;

            let parent = $(
                "#creator-map-" + element.type + "-" + element.id
            ).parent();

            if ($(parent).hasClass("children-map")) {
                $(parent).show();
            }
        },
        addGoal(idx) {
            setTimeout(function () {
                $('[data-toggle="tooltip"]').tooltip();
            }, 100);
            this.list2[idx].goalBlocks.push("");
        },
        removeGoal: function (ids, idg, event) {
            let self = this;
            this.$swal
                .fire({
                    title: event.currentTarget.getAttribute(
                        "data-confirm-title"
                    ),
                    icon: "warning",
                    html: event.currentTarget.getAttribute(
                        "data-confirm-message"
                    ),
                    showCloseButton: true,
                    showCancelButton: true,
                    reverseButtons: true,
                    focusConfirm: false,
                    confirmButtonText: window.trans.messages.Yes,
                    cancelButtonText: window.trans.messages.No,
                })
                .then(result => {
                    if (result.value) {
                        self.list2[ids].goalBlocks.splice(idg, 1);
                        self.save(this.list2[ids], ids);
                    }
                });
        },
        removeImage: function (event) {
            let $end = "/api/remove-course-image/" + this.course.id;
            let self = this;

            this.$swal
                .fire({
                    title: event.currentTarget.getAttribute(
                        "data-confirm-title"
                    ),
                    icon: "warning",
                    html: event.currentTarget.getAttribute(
                        "data-confirm-message"
                    ),
                    showCloseButton: true,
                    showCancelButton: true,
                    reverseButtons: true,
                    focusConfirm: false,
                    confirmButtonText: window.trans.messages.Yes,
                    cancelButtonText: window.trans.messages.No,
                })
                .then(result => {
                    if (result.value) {
                        axios
                            .post($end)
                            .then(response => {
                                self.course.library = "";
                                self.course.image = null;
                            })
                            .catch(err => {
                                this.$data.loader = false;
                            });
                    }
                });
        },
        uploadImage: function (event) {
            let $end = "/api/upload-course-image";
            this.loader = true;
            let self = this;

            let data = new FormData();
            data.append("id", this.form.id);
            data.append("file", event.target.files[0]);

            axios
                .post($end, data)
                .then(response => {
                    self.loader = false;
                    self.getCourse();
                })
                .catch(err => {
                    this.$data.loader = false;
                });
        },
        levelUp: function (id, level) {
            $(".dropdown-list").removeClass("w--open");
            this.list2[id].type = level - 1;
            this.change();
        },
        levelDown: function (id, level) {
            $(".dropdown-list").removeClass("w--open");
            this.list2[id].type = level + 1;
            this.change();
        },
        checkLevel(idx) {
            let parentIdx = idx;
            let foundSection = false;
            while (!foundSection) {
                parentIdx = parentIdx - 1;
                if (!["lesson", "quiz"].includes(this.list2[parentIdx].type)) {
                    foundSection = true;
                }
                if (parentIdx == 0) {
                    foundSection = true;
                }
            }

            if (this.list2[idx].type > this.list2[parentIdx].type) {
                return false;
            }
            return true;
        },
        updateDescription(child) {
            if (typeof child.parentId != "undefined") {
                this.list2[child.parentId].descriptionBlocks = JSON.stringify(
                    child.blocksData
                );
            } else {
                this.course.default_keep = child;
            }
        },
        updateCategories(data) {
            if (data.update) {
                this.getCategories();
            }
            if (data.category) {
                this.form.category = data.category.id;
                this.courseChange();
            }

            this.showAddCategoryModal = false;
        },
        restoreLesson(id) {
            $(
                "#creator-map-" + this.list2[id].type + "-" + this.list2[id].id
            ).removeClass("hide-tree-section");
            this.list2[id].deleted = false;
            this.change(false, true);
        },
        deletePermanently(idx) {
            this.list2.splice(idx, 1);
            this.change(false, true);
        },
        copyUrl() {
            navigator.clipboard.writeText(
                this.url + "/free-course/" + this.form.id
            );

            $("#alert-copy-url").css("display", "block");

            setTimeout(function () {
                $("#alert-copy-url").css("display", "none");
            }, 3000);
        },
        hideLesson: function (hide, idx) {
            this.list2[idx].hide = hide;
            this.save(this.list2[idx], idx);
        },
        getCertificates: function () {
            let $end = "/api/get-certificates/1";
            let self = this;
            axios
                .get($end)
                .then(function (res) {
                    self.certificates = res.data;
                })
                .catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
        },
        // showCertificate: function () {
        //     this.showCertificateCreator = !this.showCertificateCreator;
        // },
        // updateCertificates(res) {
        //     let self = this;
        //     setTimeout(function () {
        //         self.showCertificateCreator = false;
        //         self.$forceUpdate();
        //     }, 1000);
        //     this.getCertificates();
        //     this.form.certificate = res.id;
        //     this.courseChange();
        // },
        showQuizDescription(quizDefId, id) {
            this.quizId = quizDefId;
            let element = this.list2[id];
            this.list2[id] = element;
            if (!this.list2[id].showQuiz) {
                this.list2[id].showQuiz = true;
                element.showQuizDescription = true;
            } else {
                element.showQuizDescription = !element.showQuizDescription;
            }
        },
        updateSectionContent(data) {
            if (data.length) {
                data.forEach((changedSection) => {
                    let sectionIndex = this.list2.findIndex((section) => section.id === changedSection.section.id && section.type === changedSection.sectionType);
                    if (sectionIndex) {
                        switch (changedSection.sectionType) {
                            case 'lesson':
                            case 'quiz':
                                this.list2[sectionIndex].content = changedSection.section.content;
                                break;
                            default:
                                this.list2[sectionIndex].descriptionBlocks = changedSection.section.description_blocks;
                                break;
                        }
                    }
                })
            }
        },
        updateBlocks(element) {
            // console.log(element);
            if (typeof element.section.id != 'undefined') {
                let sectionId = this.list2.findIndex((section) => section.id === element.section.id && section.type === element.section.type);
                // console.log(sectionId)
                if (sectionId) {
                    // console.log(element)
                    this.list2[sectionId].content = JSON.stringify(element.blocksData);
                }
            }
        },
        startDrag(event) {
            const dragged = this.list2[event.oldIndex];
            if (["lesson", "quiz"].includes(dragged.type)) {
                return;
            }
            this.list2.slice(event.oldIndex + 1).every((value, key) => {
                if (dragged.type === value.type || value.type < dragged.type) {
                    return false;
                }
                this.list2[event.oldIndex + 1 + key].parentDragging = true;
                return true;
            })
            this.$forceUpdate();
        },
        endDrag() {
            this.list2.forEach((child, childIndex) => {
                this.list2[childIndex].parentDragging = false;
            })
            this.$forceUpdate();
        },
        async updateStudentProgress() {
            const trainingsForCourseResponse = await axios.get(route('course.trainings-for-course', this.course.id))
            const trainingOptions = {
                0: window.trans.course.all_students,
            }
            trainingsForCourseResponse?.data.forEach(training => Object.assign(trainingOptions, {[training.id] : training.title}))

            this.$swal
                .fire({
                    title: window.trans.course.update_student_progress,
                    input: "select",
                    inputOptions: trainingOptions,
                    inputPlaceholder: window.trans.course.for_all_or_training,
                    showCloseButton: true,
                    showCancelButton: true,
                    reverseButtons: true,
                    focusConfirm: false,
                    confirmButtonText: window.trans.messages.Yes,
                    cancelButtonText: window.trans.messages.No,
                    inputValidator: (value) => {
                        return new Promise((resolve) => {
                            if (value) {
                                resolve()
                            } else {
                                resolve(window.trans.course.please_select_students_to_update)
                            }
                        })
                    }
                })
                .then(({value: training}) => {
                    axios.post(route('course.update-student-progress'), {
                        id: this.course.id,
                        training,
                    });
                });
        }
    }
};
</script>

<style>

    .corse-creator-form .analog-clock-container {
        max-width: 20px !important;
        max-height: 20px !important;
        min-width: 20px !important;
        min-height: 20px !important;
        margin-bottom: 0;
    }

</style>

<style scoped type="text/css">

    .image-preview {
        display: none;
        width: 50%;
        height: auto;
        text-align: center;
        margin: auto;
    }

    .section-map {
    height: 65vh;
    }


    .section-title{
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    @media screen and (max-width: 1919px) {
        .section-map {
            height: 40vh;
        }

    }

      @media screen and (max-width: 1500px) {
            .section-map {
            height: 30vh;
        }
    }

/* ipad-portrait */
    @media screen and (max-height: 1180px) and (min-width: 768px) and (orientation: portrait) {

        .section-map {
            height: 40vh;
        }

    }

    @media screen and (max-width: 1180px) and (min-height: 768px) and (orientation: landscape) {

        .section-map {
            height: 40vh;
        }

    }


/* ipad pro portrait */
    @media only screen and (min-device-width: 1024px) and (max-device-width: 1024px) and (min-device-height: 1366px) and (max-device-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2) {

        .section-map {
            height: 65vh;
        }

    }


/* ipad pro landscape */

    @media only screen and (min-device-width: 1366px) and (max-device-width: 1366px) and (max-device-height: 1024px) and (max-device-height: 1024px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {

          .section-map {
            height: 57vh;
        }

    }

</style>
